import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import META from './useTrackDepletedActionBlocked.meta';

export type UseTrackDepletedActionBlockedParams = {
  action: 'upload' | 'import' | 'canvas_edit';
  days_since_cycle_start: number;
};

export const useTrackDepletedActionBlocked = () => {
  const { track } = useAnalyticsUtilities();

  const trackDepletedActionBlocked = useCallback(
    (params: UseTrackDepletedActionBlockedParams) => {
      track(META.name, params);
    },
    [track],
  );

  return { trackDepletedActionBlocked };
};
